import { getFromLocalStorage } from "../utils/webStorage";
import { useState } from "react";
import { useEffect } from "react";
// Assets
import { FaDatabase } from "react-icons/fa";
import {
  MdVideoLibrary,
  MdGroups,
  MdEventAvailable,
  MdTrendingUp,
  MdRssFeed,
} from "react-icons/md";
import { BsGraphUp } from "react-icons/bs";
import { AiFillHome } from "react-icons/ai";

export const useSchoolDashboardMenuListHook = () => {
  const [assignedRights, setAssignedRights] = useState([]);
  const loginRole = getFromLocalStorage("loginRole");

  useEffect(() => {
    const assignedRights = JSON.parse(
      getFromLocalStorage("assignedRights") || []
    );
    const assignedRightsIds = assignedRights.map((item) => item.displayName);
    setAssignedRights(assignedRightsIds);
  }, []);

  const schoolDashboardMenuList = [];

  if (loginRole === "SCHOOL ADMIN") {
    schoolDashboardMenuList.push(
      {
        text: "Homepage",
        icon: <AiFillHome />,
        path: "/schooladmindata",
        liname: "schooladmindata",
      },
      {
        text: "Library",
        icon: <MdVideoLibrary />,
        path: "/videoplayer",
        liname: "videoplayer",
      }
    );
  }

  if (
    loginRole === "COACH" ||
    loginRole === "TEAM_ADMIN" ||
    loginRole === "ATHLETE"
  ) {
    schoolDashboardMenuList.push(
      {
        text: "Feed",
        icon: <MdRssFeed />,
        path: "/teamadmindashboard",
        liname: "teamadmindashboard",
      },
      {
        text: "Trending",
        icon: <MdTrendingUp />,
        path: "/trending",
        liname: "trending",
      }
    );
  }

  if (assignedRights.includes("View Data Usage")) {
    schoolDashboardMenuList.push({
      text: "Hours",
      icon: <FaDatabase />,
      path: "/hours",
      liname: "hours",
    });
  }

  if (assignedRights.includes("Add / Remove Video Content")) {
    schoolDashboardMenuList.push({
      text: "Library",
      icon: <MdVideoLibrary />,
      path: "/videoplayer",
      liname: "videoplayer",
    });
  }

  if (
    loginRole === "SCHOOL ADMIN" ||
    loginRole === "COACH" ||
    loginRole === "TEAM_ADMIN"
  ) {
    schoolDashboardMenuList.push(
      {
        text: "Groups",
        icon: <MdGroups />,
        path: "/groups",
        liname: "groups",
      },
      {
        text: "Season",
        icon: <MdEventAvailable />,
        path: "/seasons",
        liname: "seasons",
      }
    );
  }

  if (loginRole === "SCHOOL ADMIN") {
    schoolDashboardMenuList.push({
      text: "Reports",
      icon: <BsGraphUp />,
      path: "/reports",
      liname: "reports",
    });
  }

  return schoolDashboardMenuList;
};
